import SearchResultList from "components/common/SearchResultList";
import UnitCat from "../UnitCat/UnitCat";
import { DlUnit } from "model/dl_unit/DlUnit";
import styled from "styled-components";

type UnitListProps = {
  units: DlUnit[];
};

const UnitList = ({ units }: UnitListProps) => {
  return (
    <Div>
      {/* <TopicSearchFilters searchHandle={searchHandle} /> */}
      <SearchResultList<DlUnit>
        renderSingle={(item: DlUnit, ind: number) => (
          <UnitCat
            item={new DlUnit(item)}
            catInd={ind + 1}
            key={`unit_${ind + 1}`}
          />
        )}
        results={units}
        // pageNavigation={pageNavigation}
      />
    </Div>
  );
};

const Div = styled.div`
  margin-bottom: 1rem;
`;

export default UnitList;
